import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PlexEnvironment } from '@app/env';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State, toODataString } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map } from 'rxjs/operators';

@Injectable()
export class CcctGridService extends BehaviorSubject<GridDataResult> {
  private http = inject(HttpClient);
  public environment = inject(PlexEnvironment);

  private BASE_URL = this.environment.apiUrl;
  private tableName: string = 'CostCodeCostTypeProjectCombinations?$expand=CostCodeCostType(%24expand%3DCostType,%20CostCode)';
  private readonly COST_CODE_VALUE = "CostCodeCostType.CostCode.CostCodeValue";
  public loading: boolean = false;

  public state: State = {
    skip: 0,
    take: 5
  };

  constructor() {
    super(null);
  }

  private fetch(tableName: string, state: any): Observable<GridDataResult> {
    this.loading = true;
    let oData = toODataString(state);
    if (state.filter?.filters?.some((f) => f.field === this.COST_CODE_VALUE)) {
      oData = this.castContainsForFields(oData);
    }
    let queryStr = `&${oData}&$orderby=CostCodeCostType%2FCostCode%2FCostCodeValue,CostCodeCostType%2FCostType%2FCostTypeValue&$count=true`;
    if (state.sort) {
      queryStr = `&${oData}&$count=true`;
    }

    return this.http
      .get(`${this.BASE_URL}${tableName}${queryStr}`).pipe(
        map((response) => response),
        map((response: any) => {
          return <GridDataResult>{
            data: response.value,
            total: parseInt(response['@odata.count'], 10)
          };
        }),
        finalize(() => this.loading = false)
      );
  }

  private castContainsForFields(oData: string): string {
    const field = 'CostCodeCostType/CostCode/CostCodeValue';
    const esc = field.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const re = new RegExp(`contains\\(\\s*(?!cast\\()${esc}\\s*,`, "g");
    return oData.replace(re, `contains(cast(${field}, Edm.String),`);
  }

  // For Project Resource Items
  public query(state: any): void {
    this.fetch(this.tableName, state)
      .subscribe(x => super.next(x));
  }
}
